import { render, staticRenderFns } from "./SubscriptionCancelled.vue?vue&type=template&id=87e0cd04&scoped=true"
import script from "./SubscriptionCancelled.vue?vue&type=script&lang=js"
export * from "./SubscriptionCancelled.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionCancelled.vue?vue&type=style&index=0&id=87e0cd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e0cd04",
  null
  
)

export default component.exports